export default "__VITE_ASSET__j7rngOtv__"